import axios from 'axios'
import {ResponseObject, ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  CellphoneBodyModel,
  CellphoneColumnModel,
  CellphoneDto,
} from '../model/creationCellphones.model'
import {ResponseCRUD} from '../model/response.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const CREATION_CELLPHONES_SERVICES = {
  getCellphoneList: (dto: CellphoneDto) => {
    return axios.post<ResponseObjectPaginated<CellphoneColumnModel[]>>(
      `${BASEURL}/mobileDevice/getList`,
      dto,
    )
  },
  // getCellphoneFilter(dto: any) {
  //   return axios.post<ResponseObjectPaginated<CellphoneColumnModel[]>>(
  //     `${BASEURL}/mobileDevice/getListPhone`,
  //     dto,
  //   )
  // },
  createCellphone: async (dto: CellphoneBodyModel) => {
    return await axios.post<ResponseObjectUpload>(`${BASEURL}/mobileDevice/create`, dto)
  },
  editCellphone: async (dto: CellphoneBodyModel) => {
    return await axios.put<ResponseObjectUpload>(`${BASEURL}/mobileDevice/update`, dto)
  },
  getCellphoneById: async (id: string | undefined | number) => {
    return await axios.get<ResponseObject<CellphoneColumnModel>>(
      `${BASEURL}/mobileDevice/getById`,
      {
        params: {
          id,
        },
      },
    )
  },
  deleteCellphone: (dto: any) => {
    return axios.delete<ResponseCRUD>(`${BASEURL}/mobileDevice/delete?id=${dto}`)
  },
}
